import { get, post } from "../../../../services/request";

// Fetch Block Demand Planning Reports Dropdown List

export const getBlockDemandPlanningReportsDDList = () => {
	return get('CapacityTableBlockPlanning/GetBlockDemandPlanningReportsDDList');
};

export const getAllReportsWithPagination = (payload) =>
  post("CapacityTableBlockPlanning/GetAllReportsWithPagination", payload);

export const deleteCapacityReport = (id) => {
  return post(`CapacityTableBlockPlanning/DeleteReport?id=${id}`);
};
export const exportReportsData = async (payload) => {
    try {
        const response = await get(`CapacityTableBlockPlanning/ExportBlockCapacityPlanningReport?BlockPlanningCapacityTableID=${payload.BlockPlanningCapacityTableID}`);
        return response;
    } catch (error) {
        throw error;
    }   
};
// strategiccapacityservice.js
export const getBlockCapacityTableById = (payload) =>
  get(
    `CapacityTableBlockPlanning/GetBlockCapacityTableById?BlockCapacityTableReportID=${payload.BlockCapacityTableReportID}&ReportId=${payload.ReportId}&TabNumber=${payload.TabNumber}`
  );
// strategiccapacityservice.js
export const getBlockPlanningCapacityTableReport = (payload) =>
  get(
    `CapacityTableBlockPlanning/GetBlockPlanningCapacityTableReport?BlockPlanningDemandTableID=${payload.BlockPlanningDemandTableID}&CreatedBy=${payload.CreatedBy}`
  );
export const getBlockPlanningReportNote = (payload) =>
  post("Common/GetBlockPlanningReportNote", payload);

export const updateBlockPlanningReportNote = (payload) =>
  post("Common/UpdateBlockPlanningReportNote", payload);
export const getCapacityTableGridDailyViewDataWithPagination = (payload) =>
  post(
    "CapacityTableBlockPlanning/GetCapacityTableGridDailyViewDataWithPagination",
    payload
  );
  export const GetCapacityTableGridQuarterlyViewDataWithPagination = (payload) =>
  post(
    "CapacityTableBlockPlanning/GetCapacityTableGridQuarterlyViewDataWithPagination",
    payload
  );
// strategiccapacityservice.js
export const getBlockCapacityFilterDDModel = () =>
  get("CapacityTableBlockPlanning/GetBlockCapacityFilterDDModel");
export const getWorkListByRPCEIds = (rpceIds) => {
  return post(`Common/GetWorkListByRPCEIds?rpceIds=${rpceIds}`);
};
export const getOnboardingSiteDemandPlannerLegend = () => get('SiteOnboardingPlanner/GetOnboardingSiteDemandPlannerLegend');
// strategiccapacityservice.js
export const draftBlockCapacityPlanningTableReport = (payload) =>
  post("CapacityTableBlockPlanning/DraftBlockCapacityPlanningTableReport", payload);

export const publishBlockCapacityPlanningTableReport = (payload) =>
  post("CapacityTableBlockPlanning/PublishBlockCapacityPlanningTableReport", payload);

// strategiccapacity cascading WeekQuarterByMonthYear
export const getWeekQuarterByMonthYear = (fromMonthYear, toMonthYear) =>
  get(`Common/GetWeekQuarterByMonthYear?fromMonthYear=${fromMonthYear}&toMonthYear=${toMonthYear}`);
